import { Injectable } from "@angular/core";

export enum StorageStrategy {
	SESSION,
	LOCAL
}

@Injectable({ providedIn: "root" })
export class BrowserStorage {
	stateStorage: StorageStrategy = StorageStrategy.SESSION;
	//@Output() onStateSave: EventEmitter<any> = new EventEmitter();
	//@Output() onStateRestore: EventEmitter<any> = new EventEmitter();

	constructor() {
		//this.stateStorage = _stateStorage;
	}
	setStorageStrategy(storageStrategy: StorageStrategy): void {
		this.stateStorage = storageStrategy;
	}

	getStorage(): Storage {
		switch (this.stateStorage) {
			case StorageStrategy.LOCAL:
				return window.localStorage;

			case StorageStrategy.SESSION:
				return window.sessionStorage;

			default:
				throw new Error(
					this.stateStorage +
						' is not a valid value for the state storage, supported values are "local" and "session".'
				);
		}
	}

	save(key: string, value: any): void {
		const storage = this.getStorage();

		if (Object.keys(value).length) {
			storage.setItem(key, JSON.stringify(value));
		}

		//this.onStateSave.emit(state);
	}

	load(key: string) {
		const storage = this.getStorage();
		const itemVal = storage.getItem(key);

		let retVal: any = null;

		if (itemVal) {
			retVal = JSON.parse(itemVal);
			//this.onStateRestore.emit(state);
		}
		//this.onStateSave.emit(state);
		return retVal;
	}

	clear(key: string): void {
		const storage = this.getStorage();

		if (key) {
			storage.removeItem(key);
		}
	}
}
